import { useLayoutEffect, useRef, useState } from 'react';
import Box from '@mui/material/Box';
import { DataGrid as MuiDataGrid } from '@mui/x-data-grid';

/**
 * DataGrid-Wrapper, der die MUI-Tabelle erst rendert, wenn ihr Container
 * eine echte Breite (> 0) hat.
 *
 * Hintergrund: MUI X DataGrid mit `autoHeight` misst beim Mount gelegentlich
 * eine Breite von 0 (wenn das Layout im ersten Frame noch nicht steht) und
 * bleibt dann hängen — die Flex-Spalten kollabieren, bis ein ECHTES Resize
 * kommt (ein synthetisches window-resize-Event genügt nicht, weil sich die
 * Container-Größe dabei nicht ändert). Indem wir die Tabelle erst einhängen,
 * sobald der Container vermessen werden kann, tritt der Fall nie ein.
 *
 * Alle Props werden unverändert an die DataGrid durchgereicht — die Nutzung
 * bleibt identisch (die aufrufenden Dateien importieren diesen Wrapper einfach
 * unter dem Namen `DataGrid`).
 */
export default function DataTable(props) {
  const ref = useRef(null);
  const [ready, setReady] = useState(false);

  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return undefined;
    // Normalfall: Breite steht schon vor dem Paint → sofort rendern (kein Flackern).
    if (el.clientWidth > 0) {
      setReady(true);
      return undefined;
    }
    // Sonst warten, bis der Container eine Breite bekommt.
    const ro = new ResizeObserver(() => {
      if (el.clientWidth > 0) {
        setReady(true);
        ro.disconnect();
      }
    });
    ro.observe(el);
    return () => ro.disconnect();
  }, []);

  return (
    <Box ref={ref} sx={{ width: '100%' }}>
      {ready && <MuiDataGrid {...props} />}
    </Box>
  );
}
